export const paths = {
  auth: {
    root: {
      path: '/auth/*',
      getHref: () => '/auth',
    },
    login: {
      path: '/auth/login',
      getHref: (redirectTo?: string | null | undefined) =>
        `/auth/login${redirectTo ? `?redirectTo=${encodeURIComponent(redirectTo)}` : ''}`,
    },
    forgotPassword: {
      path: '/auth/forgot-password',
      getHref: () => '/auth/forgot-password',
    },
  },
  app: {
    root: {
      path: '/',
      getHref: () => '/',
    },
    dashboard: {
      path: '',
      getHref: () => '/',
    },
    user: {
      path: 'users/*',
      getHref: (path?: string) => (path ? `/users/${path}` : `/users`),
    },
    workflow: {
      path: 'workflows/*',
      getHref: (path?: string) => (path ? `/workflows/${path}` : '/workflows'),
    },
    schedule: {
      path: 'schedules/*',
      getHref: (path?: string) => (path ? `/schedules/${path}` : '/schedules'),
    },
    execution: {
      path: 'executions/*',
      getHref: '/executions',
    },
    settings: {
      path: 'settings/*',
      getHref: () => '/settings',
    },
    admin: {
      path: 'admin/*',
      getHref: () => '/admin',
    },
  },
} as const;
